import { jsxs as l, jsx as a } from "react/jsx-runtime";
const v = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...h,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "#00B900",
          d: "M22 10.59c0-4.475-4.486-8.116-10-8.116S2 6.115 2 10.59c0 4.011 3.558 7.371 8.363 8.006.326.07.769.215.881.493.101.253.066.649.033.905l-.143.856c-.044.253-.201.988.866.539 1.067-.45 5.759-3.391 7.857-5.806C21.307 13.993 22 12.38 22 10.59"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "#fff",
          d: "M9.266 8.428h.702v.002c.107 0 .195.088.195.195v4.354a.194.194 0 0 1-.195.194h-.702a.194.194 0 0 1-.194-.194V8.622c0-.107.087-.194.194-.194M14.095 8.427h.701l-.004.003c.108 0 .195.088.195.195v4.355a.2.2 0 0 1-.057.137.2.2 0 0 1-.138.057h-.7a.2.2 0 0 1-.053-.007l-.02-.007-.008-.004-.006-.003-.004-.002-.005-.003q-.007-.003-.014-.01a.2.2 0 0 1-.05-.047l-1.999-2.7v2.587a.195.195 0 0 1-.195.194h-.701a.195.195 0 0 1-.195-.194V8.621c0-.107.087-.195.195-.195h.708l.01.001.01.001.008.002.006.001.005.001.007.002.004.001q.004 0 .008.003h.002l.004.002.01.004h.001l.006.004.01.006.007.004.01.007.002.002.003.001.014.013.012.012v.001l.016.02 2 2.697V8.62c0-.106.087-.194.195-.194M6.37 12.083h1.907v.003c.107 0 .194.087.194.194v.702a.195.195 0 0 1-.194.195H5.474a.2.2 0 0 1-.134-.055l-.005-.005a.2.2 0 0 1-.055-.135V8.625c0-.107.087-.195.195-.195h.701c.107 0 .195.088.195.195zM18.864 9.324a.195.195 0 0 1-.194.195h-1.907v.736h1.906c.108 0 .195.088.195.195v.704a.193.193 0 0 1-.195.195h-1.906v.736h1.906c.108 0 .195.088.195.195v.702a.195.195 0 0 1-.195.195h-2.802a.2.2 0 0 1-.135-.055l-.005-.005a.2.2 0 0 1-.055-.134V8.625a.19.19 0 0 1 .06-.14.2.2 0 0 1 .135-.055h2.803c.107 0 .194.088.194.195z"
        }
      )
    ]
  }
);
export {
  v as default
};
